import { render, staticRenderFns } from "./GiftcardPage.vue?vue&type=template&id=29fbd800&scoped=true&"
import script from "./GiftcardPage.vue?vue&type=script&lang=js&"
export * from "./GiftcardPage.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardPage.vue?vue&type=style&index=0&id=29fbd800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fbd800",
  null
  
)

export default component.exports